import React from 'react';

const MainContent = (props) => (
    <div id="right" className={`column content ${props.className || ''}`.trim()}>
        {props.children}
    </div>
);

export default MainContent